module.exports = __webpack_public_path__ + "media/src/assets/boatowner-56cfa6f8a337ac8507dd4dca84ca598b.png";